import React, { Fragment } from 'react';
import {
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  Label,
  Input,
  Spinner,
} from 'reactstrap';
import apiResponse from '../../../../services/apiResponse';
import Doughnut from './../Chart/Doughnut';
import CustomSelect from '../../../../helpers/ui/CustomSelect';
import PresensiIzinComponent from './PresensiIzinComponent';
import PresensiLateComponent from './PresensiLateComponent';
import IndexBloc from './../Blocs/IndexBloc';
import moment from 'moment';

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj['label'] = data[label];
    newObj['value'] = data[value];

    return newObj;
  });
};

class PresensiComponent extends React.Component {
  indexBloc = new IndexBloc();

  constructor(props) {
    super(props);
    this.state = {
      optionUnits: [],
      selectedUnit: null,
      presensiChart: [],
      presensiSummary: null,
      presensiLate: [],
      presensiCuti: [],
      filterDate: moment().format('YYYY-MM-DD'),
      loadingPresensiChart: true,
      loadingPresensiSummary: true,
      loadingPresensiCuti: true,
    };
  }

  loadData = () => {
    let query = {
      date: document.getElementById('filter_date').value,
      work_unit: this.state.selectedUnit,
    };

    this.setState({
      loadingPresensiChart: true,
      loadingPresensiSummary: true,
      loadingPresensiCuti: true,
    });

    // FILTER
    this.indexBloc.fetchWorkUnit();

    //DATA
    this.indexBloc.fetchPresensiChart(query);
    this.indexBloc.fetchPresensiSummary(query);
    this.indexBloc.fetchPresensiCuti(query);
  };

  componentDidMount() {
    // FILTER
    this.indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            console.log('testing data' + response);
            this.setState({
              optionUnits: reformatOptions(
                response,
                'work_unit_name_tabs',
                'work_unit_name_full'
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    //DATA
    this.indexBloc.presensiChartChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              presensiChart: response.group,
              loadingPresensiChart: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.presensiSummaryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              presensiSummary: response,
              loadingPresensiSummary: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.presensiCutiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            this.setState({
              presensiCuti: response,
              loadingPresensiCuti: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.loadData();
  }

  componentWillUnmount() {
    this.indexBloc.workUnitChannel?.unsubscribe();
    this.indexBloc.presensiChartChannel?.unsubscribe();
    this.indexBloc.presensiSummaryChannel?.unsubscribe();
    this.indexBloc.presensiCutiChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        {/* FILTER */}
        <Row>
          <Col md={12}>
            <Card
              style={{
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle style={{ marginBottom: '10px' }}>
                  <h5 style={{ fontWeight: 'bold' }}>Filter : </h5>
                </CardTitle>

                <Row className="mb-3">
                  <Label className="col-md-2 col-form-label">Tanggal</Label>
                  <Col md="10">
                    <Input
                      name="filter_date"
                      id="filter_date"
                      placeholder="Filter Tanggal"
                      errorMessage="Masukkan Filter Tanggal"
                      type="date"
                      className="form-control"
                      onChange={(e) => {
                        this.setState({
                          filterDate: e.target.value,
                        });
                        this.loadData();
                      }}
                      value={this.state.filterDate}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Label className="col-md-2 col-form-label">Unit Kerja</Label>
                  <Col md="10">
                    <CustomSelect
                      isAvForm={false}
                      options={this.state.optionUnits}
                      name="unit_kerja"
                      placeholder="Unit Kerja"
                      onChange={(v) => {
                        this.setState({
                          selectedUnit: v != null ? v.value : '',
                        });
                        setTimeout(() => {
                          this.loadData();
                        }, 500);
                      }}
                      isClearable={true}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* BADGE */}
        <Row>
          <Col md={12} style={{ marginBottom: '10px' }}>
            <h5 style={{ fontWeight: 'bold' }}>
              Informasi Data Presensi Pegawai{' '}
            </h5>
          </Col>
        </Row>

        {/* GRAPH PRESENSI PEGAWAI */}
        <Row>
          <Col md={6}>
            <Card
              style={{
                borderRadius: '20px',
                boxShadow:
                  '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
              }}
            >
              <CardBody>
                <CardTitle>Daftar Presensi Pegawai</CardTitle>
                {this.state.loadingPresensiChart === false ? (
                  <Doughnut options={this.state.presensiChart} height="230px" />
                ) : (
                  <div className="text-center" style={{ marginTop: '90px' }}>
                    <Spinner className="m-2" color="primary" />
                  </div>
                )}
              </CardBody>
            </Card>

            {/* GRAPH PRESENSI MESIN DAN MOBILE */}
            <Row>
              {/* MESIN ABSEN */}
              <Col md={6}>
                <Card
                  style={{
                    borderRadius: '20px',
                    boxShadow:
                      '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <CardBody>
                    {this.state.loadingPresensiSummary === false ? (
                      <div>
                        <h4 className="mb-1 mt-1">
                          <span>{this.state.presensiSummary?.[0].value}</span>
                        </h4>
                        <p className="text-muted mb-0">{'Mesin Absen'}</p>
                      </div>
                    ) : (
                      <div className="text-center">
                        <Spinner className="m-2" color="primary" />
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>

              {/* MOBILE ABSEN */}
              <Col md={6}>
                <Card
                  style={{
                    borderRadius: '20px',
                    boxShadow:
                      '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <CardBody>
                    {this.state.loadingPresensiSummary === false ? (
                      <div>
                        <h4 className="mb-1 mt-1">
                          <span>{this.state.presensiSummary?.[1].value}</span>
                        </h4>
                        <p className="text-muted mb-0">{'Mobile Absen'}</p>
                      </div>
                    ) : (
                      <div className="text-center">
                        <Spinner className="m-2" color="primary" />
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>

          <Col md={6}>
            <PresensiIzinComponent
              options={this.state.presensiCuti}
              loading={this.state.loadingPresensiCuti}
            />
          </Col>
        </Row>

        {/* GRAPH IZIN DAN TELAT */}
        <Row>
          <Col md={12}>
            <PresensiLateComponent
              workUnit={this.state.selectedUnit}
              filterDate={this.state.filterDate}
            />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default PresensiComponent;
